
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL_RR
const supabaseKey = process.env.REACT_APP_ANON_KEY_RR
console.log(supabaseKey, supabaseUrl)
const supabase = createClient(supabaseUrl, supabaseKey)

export default supabase